var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 143,
    viewBox: "0 0 165 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.199 120.283C114.348 120.283 141.222 93.4089 141.222 60.1416C141.222 26.8743 114.348 0 81.199 0C48.0501 0 21.1758 26.8743 21.1758 60.1416C21.1758 93.4089 48.0501 120.283 81.199 120.283Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0378 28.2948H122.396C125.83 28.2948 128.434 30.8994 128.434 34.3326V88.4364C128.434 91.8697 125.83 94.4742 122.396 94.4742H37.0378C33.6046 94.4742 31 91.8697 31 88.4364V34.3326C31 30.8994 33.8413 28.2948 37.0378 28.2948Z",
    fill: "url(#paint0_linear_6624_30277)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6624_30277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.072 34.3284L112.798 92.7392C112.798 94.7346 111.165 96.2765 109.17 96.2765H52.21C50.2146 96.2765 48.582 94.6439 48.582 92.7392V17.6396C48.582 15.6442 50.2146 14.1023 52.21 14.1023H93.4785L112.072 34.3284Z",
    fill: "url(#paint1_linear_6624_30277)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4954 26.347H58.1947C57.5598 26.347 57.0156 25.8028 57.0156 25.1679C57.0156 24.533 57.5598 23.9888 58.1947 23.9888H85.4954C86.1303 23.9888 86.6745 24.533 86.6745 25.1679C86.6745 25.8028 86.1303 26.347 85.4954 26.347Z",
    fill: "#D5DDEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7159 32.8774H58.1947C57.5598 32.8774 57.0156 32.3332 57.0156 31.6983C57.0156 31.0634 57.5598 30.5192 58.1947 30.5192H68.6252C69.2601 30.5192 69.8043 31.0634 69.8043 31.6983C69.8043 32.3332 69.2601 32.8774 68.7159 32.8774Z",
    fill: "#D5DDEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4766 14.1023V30.2469C93.4766 32.5144 95.472 34.3284 97.7395 34.3284H112.07",
    fill: "#D5DDEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.473 46.6697H94.5749H92.1216H58.5374C58.1144 46.6697 57.6914 47.0935 57.6914 47.687C57.6914 48.1956 58.0298 48.7043 58.5374 48.7043H92.1216H94.5749H104.388C104.98 48.7043 105.319 48.2804 105.319 47.687C105.319 47.1783 104.98 46.6697 104.473 46.6697Z",
    fill: "#D5DDEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.092 62.983V89.6205C130.092 93.0538 127.369 95.8952 123.817 95.8952H36.091C32.6577 95.8952 29.8164 93.0538 29.8164 89.6205V60.7336",
    stroke: "#1676EE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.633 48.0658H94.9304C92.2074 48.0658 89.6029 49.0129 87.5902 50.6704L80.3685 56.5898C78.3559 58.2472 75.7514 59.1944 73.0284 59.1944H41.7737C38.5772 59.1944 35.9727 61.7989 35.9727 64.9954C35.9727 65.2322 35.9727 65.5874 36.091 65.8241L41.8921 96.3685C42.3657 99.2098 44.7334 101.341 47.6932 101.341H114.583C117.424 101.341 119.91 99.3282 120.384 96.4869L128.434 54.6956C129.026 51.4991 126.895 48.6577 123.699 48.0658C123.225 48.0658 122.87 48.0658 122.633 48.0658Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6624_30277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.067 39.897H99.0766C95.525 39.897 92.2101 41.0808 89.4871 43.3302L80.016 51.0255C77.4114 53.1565 73.9782 54.4588 70.4265 54.4588H29.7007C25.5571 54.4588 22.2422 57.8921 22.2422 61.9173C22.2422 62.2725 22.2422 62.6276 22.3606 62.9828L29.8191 102.88C30.411 106.668 33.6075 109.391 37.2776 109.391H124.412C128.2 109.391 131.278 106.787 131.87 102.998L142.407 48.421C143.117 44.2773 140.394 40.6073 136.251 39.7786C135.896 39.897 135.422 39.897 135.067 39.897Z",
    fill: "url(#paint2_linear_6624_30277)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.448 35.8893C141.712 35.8893 143.548 34.0537 143.548 31.7893C143.548 29.525 141.712 27.6893 139.448 27.6893C137.183 27.6893 135.348 29.525 135.348 31.7893C135.348 34.0537 137.183 35.8893 139.448 35.8893Z",
    fill: "#EAEEF9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.351 22.5894C136.897 22.5894 138.151 21.3358 138.151 19.7894C138.151 18.243 136.897 16.9894 135.351 16.9894C133.804 16.9894 132.551 18.243 132.551 19.7894C132.551 21.3358 133.804 22.5894 135.351 22.5894Z",
    fill: "#EAEEF9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9484 31.7893C23.4948 31.7893 24.7484 30.5357 24.7484 28.9893C24.7484 27.4429 23.4948 26.1893 21.9484 26.1893C20.402 26.1893 19.1484 27.4429 19.1484 28.9893C19.1484 30.5357 20.402 31.7893 21.9484 31.7893Z",
    fill: "#EAEEF9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6492 93.3894C18.5211 93.3894 20.8492 91.0613 20.8492 88.1894C20.8492 85.3175 18.5211 82.9894 15.6492 82.9894C12.7773 82.9894 10.4492 85.3175 10.4492 88.1894C10.4492 91.0613 12.7773 93.3894 15.6492 93.3894Z",
    fill: "#EAEEF9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.866 117.2L116.473 99.8404C98.1134 113.342 72.9414 100.178 72.9414 78.1416C72.9414 63.1453 85.165 50.9939 100.143 50.9939C121.788 50.9939 135.074 75.2966 122.464 93.6683L139.954 111.124C141.645 112.812 141.645 115.512 139.954 117.2C138.263 118.887 135.557 118.887 133.866 117.2ZM100.143 59.6252C89.8999 59.6252 81.5414 67.9672 81.5414 78.1898C81.5414 94.6327 101.254 102.541 112.559 91.9806C125.363 80.0221 116.811 59.6252 100.143 59.6252Z",
    fill: "#989FB0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2573 82.2403C98.2089 81.8546 98.1606 81.4688 98.1606 81.0349C98.1606 79.4436 98.837 77.997 100.528 76.7433L101.977 75.6825C102.895 75.0074 103.282 74.2359 103.282 73.3197C103.282 71.9695 102.316 70.6676 100.286 70.6676C98.1606 70.6676 97.2426 72.3553 97.2426 74.043C97.2426 74.3805 97.291 74.7181 97.3393 75.0074L93.5707 74.8627C93.4741 74.4288 93.4258 73.9466 93.4258 73.5126C93.4258 70.2819 95.8415 67.1958 100.238 67.1958C104.876 67.1958 107.292 70.089 107.292 73.1268C107.292 75.4896 106.084 77.1291 104.345 78.3828L103.137 79.2507C102.074 79.974 101.543 80.9384 101.543 82.1439V82.3368H98.2573V82.2403ZM99.9483 84.1691C101.253 84.1691 102.316 85.23 102.316 86.5319C102.316 87.8338 101.253 88.8947 99.9483 88.8947C98.6438 88.8947 97.5808 87.8338 97.5808 86.5319C97.5808 85.23 98.6438 84.1691 99.9483 84.1691Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6624_30277",
    x: 26.582,
    y: 3.10229,
    width: 108.215,
    height: 126.174,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6624_30277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6624_30277",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6624_30277",
    x: 0.242188,
    y: 28.7786,
    width: 164.277,
    height: 113.613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6624_30277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6624_30277",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6624_30277",
    x1: 79.7248,
    y1: 30.5938,
    x2: 79.7248,
    y2: 67.7396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6624_30277",
    x1: 80.6689,
    y1: 12.2015,
    x2: 80.6689,
    y2: 97.1624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6624_30277",
    x1: 82.3417,
    y1: 38.1684,
    x2: 82.3417,
    y2: 110.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateImg);
export default __webpack_public_path__ + "static/media/emptyStateImg.36d5ab761c381a91c9e2533d309dffcf.svg";
export { ForwardRef as ReactComponent };